import angular from 'angular';
import UIRouter from 'angular-ui-router';

import createStub from '../olr-common/createStub';
import './addSubPopup.html';
import './styles/index.scss';
import template from './index.html';
import DashboardController from './DashboardController';

    
let namespace = angular.module('olr-mainfe-dashboard', [
  UIRouter,
  'olr-common'
]);

namespace.config(function($stateProvider) {
  $stateProvider.state('olr.mainfe.dashboard', {
    url: '/dashboard',
    controller: DashboardController,
    controllerAs: 'dashboardCtrl',
    template: template
  });
});

namespace.controller('DashboardController', DashboardController);

export default namespace.name;
  




/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-dashboard/index.js
 **/